const __WEBPACK_NAMESPACE_OBJECT__ = require("@datadog/browser-rum");